import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=90c5e1ec&scoped=true"
import script from "./Offices.vue?vue&type=script&lang=js"
export * from "./Offices.vue?vue&type=script&lang=js"
import style0 from "./Offices.vue?vue&type=style&index=0&id=90c5e1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c5e1ec",
  null
  
)

export default component.exports